import { observer } from 'mobx-react-lite'
import { AllSelection } from 'prosemirror-state'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { useAlmanacEditorState } from 'stores/EditorState'
import { ImproveQuality as ImproveQualityIcon } from 'blaze-ui/icons/36'
import { AIAssistantProps } from '../Types'
import { Action, ActionProps } from './Action'
import { useImproveQuality } from 'hooks/useImproveQuality'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { BarChartSquareUp01 } from 'blaze-ui/icons/16/BarChartSquareUp01'

export const ImproveQuality = observer(function ImproveQuality({
  article,
  layerId,
  ...props
}: AIAssistantProps & Omit<ActionProps, 'label' | 'tooltip'>) {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const { improveQuality, isLoading } = useImproveQuality({ articleId: article.id, layerId })
  const editorState = useAlmanacEditorState()

  const handlePress = () => {
    if (!editorState) return

    const selection = editorState.selection.empty ? new AllSelection(editorState.view.state.doc) : editorState.selection

    if (
      selection.empty ||
      selection.content().content.textBetween(0, selection.content().content.size).trim().length < 1
    ) {
      showToastMessage(`Try selecting some text you'd like Blaze to improve!`, 'info')
      return
    }

    improveQuality()
  }

  return (
    <Action
      label="Improve Quality"
      icon={isSystemRedesignEnabled ? BarChartSquareUp01 : ImproveQualityIcon}
      isDisabled={isLoading}
      {...props}
      onPress={handlePress}
    />
  )
})
